/**
 * Collaborators component
 * - List all the collaborators of this submission
 * - Todo: Need to detect changes and provide an update button to save the collaborator
 */

<template>
  <div>
    <sh-spacer by="1"/>

    <el-row>
      <el-col>
        <sh-inliner>
          <h2 class="is-required--custom">Director<span v-if="form.directors.length > 1">s</span></h2>
          &nbsp;
          <el-button
            v-if="editable"
            icon="el-icon-circle-plus" type="text"
            @click="addCollaborator('directors', 'director')"
          >Add</el-button>
        </sh-inliner>
      </el-col>
    </el-row>

    <el-row>
      <CollaboratorTable
        v-model="form.directors"
        defaultRole="director"
        :disabled="!editable"
        @editing="editing"

        :updateFn="$_collaboratorTableUpdateFn"
        :createFn="$_collaboratorTableCreateFn"
        :removeFn="$_collaboratorTableRemoveFn"
      />

    </el-row>

    <sh-spacer by="3"/>

    <el-row>
      <el-col>
        <sh-inliner>
          <h2>Contributor<span v-if="form.contributors.length > 1">s</span></h2>
          &nbsp;
          <el-button
            v-if="editable"
            icon="el-icon-circle-plus" type="text"
            @click="addCollaborator('contributors')"
          >Add</el-button>
        </sh-inliner>

        <p style="margin-top: 0;">
          Add your collaborators - those who worked silently and tirelessly - to your film here. This will help us send an invite and notify collaborators upon your film page release. This data is kept confidential and we will not use it for unsolicited messaging.
        </p>
      </el-col>
    </el-row>
    <el-row>
      <CollaboratorTable
        v-model="form.contributors"
        :disabled="!editable"
        @editing="editing"

        :updateFn="$_collaboratorTableUpdateFn"
        :createFn="$_collaboratorTableCreateFn"
        :removeFn="$_collaboratorTableRemoveFn"
      />
    </el-row>
  </div>
</template>

<script>
import webcall from '@/libs/webcall';
import CardCol from '@/components/Shared/CardCol';
import CollaboratorTable from './CollaboratorItem/CollaboratorTable';
import stepMixin from '../../Mixins/stepMixin';

export default {
  name: 'Collaborators',
  props: [
    'value',
  ],
  mixins: [
    stepMixin,
  ],
  components: {
    // CollaboratorItem,
    CardCol,
    CollaboratorTable,
  },
  watch: {
    'form.directors': function directors() { this.updateForm(); },
    'form.contributors': function contributors() { this.updateForm(); },
  },
  data() {
    return {
      form: {
        directors: [],
        contributors: [],
      },
      activeEditing: 0,
    };
  },
  computed: {
    hasUnsaved() {
      return this.activeEditing > 0;
    },
  },
  mounted() {
    this.value.collaborators.forEach((human) => {
      if (human.role === 'director') {
        this.form.directors.push(human);
      } else {
        this.form.contributors.push(human);
      }
    });

    if (this.form.directors.length === 0 && this.editable) {
      this.form.directors = [{
        editable: true,
        role: 'director',
      }];
    }

    if (this.form.contributors.length === 0 && this.editable) {
      this.form.contributors = [{
        editable: true,
      }];
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasUnsaved) {
      return this.$alert(null, 'Unsaved change', {
        confirmButtonText: 'Return',
        message: 'Collaborator infomation is not saved. Please save or discard your changes first.',
      });
    }
    return next();
  },

  methods: {
    updateForm() {
      // Trigger store update
      this.$emit('input');
    },
    addCollaborator(type, role) {
      this.form[type].push({
        role,
        editable: true,
      });
    },
    editing(status) {
      this.activeEditing += (status) ? 1 : -1;
    },

    // Collaborator update methods
    $_collaboratorTableCreateFn(human) {
      return webcall.submission.collaborators.add(this.value.id, human);
    },
    $_collaboratorTableUpdateFn(humanId, human) {
      return webcall.submission.collaborators.update(this.value.id, humanId, human);
    },
    $_collaboratorTableRemoveFn(humanId) {
      return webcall.submission.collaborators.delete(this.value.id, humanId);
    },

  },
};
</script>

<style scoped lang="scss">
.collaborator__row {
  display: flex;
  flex-wrap: wrap;

  > .el-col {
    margin-bottom: 3em;
  }
}

.collaborator__item {
  height: 340px;
}

.collaborator__item .el-form-item {
  margin-bottom: 0.75em;
}
</style>


// WEBPACK FOOTER //
// src/components/Submission/steps/CollaboratorDetails/index.vue